<h5>
  Edit Views
  <span style="float:right; cursor:pointer" (click)="close()"><mat-icon aria-hidden="false" aria-label="Settings">close</mat-icon></span>
</h5>

<div mat-dialog-content>

  <div class="row m-0 p-0" *ngFor="let view of views">
    <div class="col-md-9 p-0 pr-3 mr-1">
      <input class="w-100" [value] = "view.viewName" (keyup)="changeName($event, view.id)" (onchange)="changeName($event, view.id)">
    </div>
    <div class="col-md-1 p-0 mr-2"><span (click)="saveView(view.id)" class="block-icon"><mat-icon  color="secondary"  aria-hidden="false" aria-label="Edit">save</mat-icon></span></div>
    <div class="col-md-1 p-0"><span (click)="deleteView(view.id)" class="block-icon"><mat-icon color="error" aria-hidden="false" aria-label="Delete">delete</mat-icon></span></div>
  </div>

</div>



